import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { formatLedgerAmount } from '../manage/clientLedgerTypes';

function SettlementSummary({ summary, monthLabel }) {
  const { t: tr, i18n } = useTranslation();
  const amount = cents => formatLedgerAmount(cents / 100, i18n.language);
  const incomplete = count => (count > 0 ? (
    <div className="text-warning small">{tr('billing:settlementSummary.incomplete', { count })}</div>
  ) : null);

  return (
    <section className="mb-3" aria-label={tr('billing:settlementSummary.title')}>
      <div className="mb-2 text-muted">
        {tr('billing:settlementSummary.context', { month: monthLabel, count: summary.count })}
      </div>
      <div className="row">
        <div className="col-12 col-md-3 mb-2">
          <div>{tr('billing:settlementSummary.charges')}</div>
          <strong>{amount(summary.chargeCents)}</strong>
          <div className="text-muted small">
            {tr('billing:settlementSummary.chargeSplit', {
              approved: amount(summary.approvedCents), draft: amount(summary.draftCents),
            })}
          </div>
          {incomplete(summary.incompleteChargeCount)}
        </div>
        <div className="col-12 col-md-3 mb-2">
          <div>{tr('billing:discounts.title')}</div>
          <strong>{summary.unknownDiscountCount === summary.count && summary.count > 0 && !summary.discountCents ? '—' : amount(summary.discountCents || 0)}</strong>
          {summary.unknownDiscountCount > 0 && (
          <div className="text-warning small">
            {tr('billing:settlementSummary.unknownDiscounts', { count: summary.unknownDiscountCount })}
          </div>
          )}
        </div>
        <div className="col-12 col-md-3 mb-2">
          <div>{tr('billing:settlementSummary.payments')}</div>
          <strong>{amount(summary.paymentCents)}</strong>
          <div className="text-muted small">{tr('billing:settlementSummary.paymentHint')}</div>
          {incomplete(summary.incompletePaymentCount)}
        </div>
        <div className="col-12 col-md-3 mb-2">
          <div>{tr('billing:settlementSummary.due')}</div>
          <strong>{amount(summary.dueCents)}</strong>
          <div className="text-muted small">{tr('billing:settlementSummary.dueHint')}</div>
          {incomplete(summary.incompleteBalanceCount)}
        </div>
      </div>
    </section>
  );
}

SettlementSummary.propTypes = {
  monthLabel: PropTypes.string.isRequired,
  summary: PropTypes.shape({
    count: PropTypes.number.isRequired,
    chargeCents: PropTypes.number.isRequired,
    approvedCents: PropTypes.number.isRequired,
    draftCents: PropTypes.number.isRequired,
    paymentCents: PropTypes.number.isRequired,
    dueCents: PropTypes.number.isRequired,
    incompleteBalanceCount: PropTypes.number.isRequired,
    incompleteChargeCount: PropTypes.number.isRequired,
    incompletePaymentCount: PropTypes.number.isRequired,
    discountCents: PropTypes.number,
    unknownDiscountCount: PropTypes.number,
  }).isRequired,
};

export default SettlementSummary;
